import React from 'react';
import moment from 'moment';

import Modal from '../../../../../../../../../../components/Modal';
import AdvisorProfile from '../../../AdvisorProfile';

import './ModuleBlock.scss';

const sessionWasAttended = (session) => {
  if (session.module_instance_status !== null) {
    return session.module_instance_status.category === 'completed' || session.module_instance_status.category === 'awaiting student feedback';
  }
  return false;
};

const getSessionStatus = session => {
  return sessionWasAttended(session) ? (<b className="text-success">Attended</b>) : (<b className="text-danger">Not Attended</b>);
};

const getJobPositionName = (jobPosition) => {
  if (jobPosition.company !== null) {
    return `${jobPosition.title} at ${jobPosition.company.name}`;
  }
  return jobPosition.title;
};

const renderAdvisor = Advisor => {
  if (Advisor !== null) {
    return (
      <div className="past-sessions-module-block__advisor">
        <img src={IMAGECACHELINK + '/' + IMAGESTAGE + '/300x300/' + Advisor.photo} alt={`${Advisor.first_name} ${Advisor.last_name}`} className="img-circle" />
        <p className="past-sessions-module-block__advisor-name">{`${Advisor.first_name} ${Advisor.last_name}`}</p>
        {Advisor.job_positions && Advisor.job_positions.length > 0 && (
          <div>
            <p className="past-sessions-module-block__advisor-job-position">{getJobPositionName(Advisor.job_positions[0])}</p>
          </div>
        )}
      </div>
    );
  }

  return null;
};

const renderWatchLink = Instance => {
  if (sessionWasAttended(Instance)) {
    const Recording = Instance.zoom_recordings.find(x => x.file_type === 'MP4');

    if (typeof Recording !== 'undefined' && Recording.file_url !== null) {
      const ID = Recording.file_url.split('/').slice(-1)[0].slice(0, -4);

      return (
        <a href={window.location.origin + "/recordings/" + ID} target="_blank">
          <span className="fa fa-youtube-play" />
          Watch session video
        </a>
      );
    }
  }
  return null;
};

const renderAdvisorFeedbackBtn = Instance => {
  if (sessionWasAttended(Instance)) {
    if (Instance.module_component_instances.length > 0) {
      return (
        <a href="#" onClick={((e) => {
          e.preventDefault();
          this['AdvisorFeedbackModal__' + Instance.id].openModal();
        })}>
          <span className="fa fa-commenting" />
          View advisor feedback
        </a>
      );
    }
  }

  return null;
};

const renderFeedbackModalContent = Instance => {
  if (Instance.module_component_instances.length > 0) {
    return (
      <div>
        <h3 className="AdvisorFeedback__Title" >{Instance.advisor.first_name + '\'s Feedback'}</h3>
        {Instance.module_component_instances[0].field_answers.map(Answer => (
          <div className="AdvisorFeedbackEntry">
            <b><p>{Answer.field.label}</p></b>
            <p>{Answer.value}</p>
          </div>
        ))}
      </div>
    );
  }

  return (
    <p className="text-center">No feedback was given for this session</p>
  );
};

export default props => {
  const Data = props['module-block-data'];

  if (Data.advisor !== null) {
    return (
      <div className="pastSession__Wrapper">
        <Modal onRef={ref => (this['AdvisorFeedbackModal__' + Data.id] = ref)}>
          {renderFeedbackModalContent(Data)}
        </Modal>
        <Modal onRef={ref => (this['AdvisorkModal__' + Data.id] = ref)}>
          <AdvisorProfile advisorData={Data.advisor} />
        </Modal>
        <div className="pastSession--TimeBreak">{moment(Data.scheduled_to).format('MMM DD, YYYY')}</div>
        <div className="past-sessions-module-block">
          <div className="row">
            <div className="col-md-4">
              {Data.Industry && (
                <p className="past-sessions-module-block__module-industry">{Data.Industry.name}</p>
              )}
              {renderAdvisor(Data.advisor)}
            </div>
            <div className="col-md-8">
              <div className="past-sessions-module-block__module">
                <p className="past-sessions-module-block__module-date-and-status">
                  <span>{getSessionStatus(Data)}</span>
                </p>
                <p className="past-sessions-module-block__module-title">{Data.module.module_name || ''}</p>
                <p style={{ "whiteSpace": "pre-line" }} className="past-sessions-module-block__module-description">{Data.module.student_module_summary || ''}</p>
                <div className="past-sessions-module-block__module-feedback">
                  <a href="#" onClick={((e) => {
                    e.preventDefault();
                    this['AdvisorkModal__' + Data.id].openModal();
                  })}>
                    <span className="fa fa-user" />
                    View advisor profile
                  </a>
                  {renderAdvisorFeedbackBtn(Data)}
                  {renderWatchLink(Data)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/routes/progress-report/routes/ProgressReport/components/ProgressReport/components/PastSessions/components/ModuleBlock/index.js